export const REQUEST_OBJECTIVE_REVIEW = "request_objective_review"
export const FETCH_OBJECTIVE_REVIEW_SUCCESS = "fetch_objective_review_success"
export const FETCH_OBJECTIVE_REVIEW_FAILURE = "fetch_objective_review_failure"
export const REVIEW_OBJECTIVE_ALL_ACTION_CHANGED = "review_objective_all_action_changed"

export const CLEAR_OBJECTIVE_REVIEW_STATE = "clear_objective_review_state"